import React from 'react';

const SidebarNav = ({ activeTab, setActiveTab, user, onLogout }) => {
    return (
        <aside className="admin-sidebar">
            <div className="admin-sidebar-brand">
                <div className="admin-brand-text">
                    <span className="brand-name">bs clads</span>
                    
                </div>
            </div>

            <nav className="admin-nav-menu">
                <button
                    className={`admin-nav-item ${activeTab === 'dashboard' ? 'active' : ''}`}
                    onClick={() => setActiveTab('dashboard')}
                >
                    <i className="fa fa-dashboard" /> <span>Dashboard</span>
                </button>
                <button
                    className={`admin-nav-item ${activeTab === 'sliders' ? 'active' : ''}`}
                    onClick={() => setActiveTab('sliders')}
                >
                    <i className="fa fa-sliders" /> <span>Hero Sliders</span>
                </button>
                <button
                    className={`admin-nav-item ${activeTab === 'banners' ? 'active' : ''}`}
                    onClick={() => setActiveTab('banners')}
                >
                    <i className="fa fa-flag" /> <span>Page Banners</span>
                </button>
                <button
                    className={`admin-nav-item ${activeTab === 'products' ? 'active' : ''}`}
                    onClick={() => setActiveTab('products')}
                >
                    <i className="fa fa-cubes" /> <span>Products</span>
                </button>
                <button
                    className={`admin-nav-item ${activeTab === 'projects' ? 'active' : ''}`}
                    onClick={() => setActiveTab('projects')}
                >
                    <i className="fa fa-picture-o" /> <span>Projects Gallery</span>
                </button>
                <button
                    className={`admin-nav-item ${activeTab === 'testimonials' ? 'active' : ''}`}
                    onClick={() => setActiveTab('testimonials')}
                >
                    <i className="fa fa-comments" /> <span>Testimonials</span>
                </button>
                <button
                    className={`admin-nav-item ${activeTab === 'settings' ? 'active' : ''}`}
                    onClick={() => setActiveTab('settings')}
                >
                    <i className="fa fa-cog" /> <span>Site Settings</span>
                </button>
                <button
                    className={`admin-nav-item ${activeTab === 'inquiries' ? 'active' : ''}`}
                    onClick={() => setActiveTab('inquiries')}
                >
                    <i className="fa fa-envelope" /> <span>Customer Inquiries</span>
                </button>
            </nav>

            <div className="admin-sidebar-footer">
                <div className="user-info">
                    <i className="fa fa-user-circle" />
                    <div>
                        <strong>{user.username || 'admin'}</strong>
                    </div>
                </div>
                <button onClick={onLogout} className="admin-btn-logout" title="Logout">
                    <i className="fa fa-sign-out" /> Logout
                </button>
            </div>
        </aside>
    );
};

export default SidebarNav;
